import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import SubmitButton from "@/components/button/SubmitButton.vue";

type Props = {
  value: boolean;
  title: string;
};
type Emits = {
  (e: "input", val: boolean): void;
  (e: "submit"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserDepartmentDialog',
  props: {
    value: { type: Boolean },
    title: null
  },
  emits: ["input", "submit"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  title: string;
};




const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const onClose = () => {
  modelValue.value = false;
};
const onSubmit = () => {
  emits("submit");
};

return { __sfc: true,props, emits, modelValue, onClose, onSubmit, SubmitButton }
}

})